import { Media } from 'media'
import { ComponentType } from 'react'
import { AgentsDesktop } from './agents-desktop'
import { AgentsMobile } from './agents-mobile'

export const Agents: ComponentType = () => (
  <>
    <Media at="xs">
      <AgentsMobile />
    </Media>
    <Media greaterThan="xs">
      <AgentsDesktop />
    </Media>
  </>
)
